// Валидатор даты фактического возврата перед POST /in_home.
// v-calendar (model-config type: "string") при снятии выбора даты возвращает
// пустую строку, а setDates-путь через moment.format(null) — "Invalid date";
// оба значения сервер отверг бы валидацией end_date (HB-поток
// «End date не может быть пустым»), поэтому режем их до запроса.
export function isArrivalEndDateValid(endDate) {
  if (typeof endDate !== "string") return false;
  const trimmed = endDate.trim();
  return trimmed.length > 0 && trimmed !== "Invalid date";
}
